import type { NotificationParams } from '@xtreed/academy-shared';
import { api } from './api';

export interface AppNotification {
  id: string;
  userId: string;
  code?: string | null;
  params?: NotificationParams | null;
  title?: string | null;
  message?: string | null;
  type: string; // 'info' | 'success' | 'warning' | 'error'
  category?: string; // 'comment' | 'gamification' | 'system'
  actionUrl?: string;
  read: boolean;
  readAt?: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

class NotificationsService {
  async getAll(
    page = 1,
    limit = 20,
  ): Promise<{
    data: AppNotification[];
    meta: { page: number; limit: number; total: number; totalPages: number };
  }> {
    const { data } = await api.get(
      `/notifications?page=${page}&limit=${limit}`,
    );
    const unwrapped = data?.data || data;
    return {
      data: Array.isArray(unwrapped) ? unwrapped : unwrapped?.data || [],
      meta: data?.meta ||
        unwrapped?.meta || {
          page,
          limit,
          total: 0,
          totalPages: 1,
        },
    };
  }

  async getUnreadCount(): Promise<number> {
    const { data } = await api.get('/notifications/unread-count');
    const unwrapped = data?.data || data;
    return unwrapped?.count ?? 0;
  }

  async markAsRead(id: string): Promise<AppNotification> {
    const { data } = await api.patch(`/notifications/${id}/read`);
    return data?.data || data;
  }

  async markAllAsRead(): Promise<void> {
    await api.patch('/notifications/read-all');
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/notifications/${id}`);
  }
}

export const notificationsService = new NotificationsService();
